import { Component, OnInit, Input } from '@angular/core';
import { httpService } from '../service/servicio';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { AppComponent } from '../app.component';


@Component({
  selector: 'app-datosarticulos',
  templateUrl: './datosarticulos.component.html',
  styleUrls: ['./datosarticulos.component.css']
})
export class DatosarticulosComponent  {

    constructor(public http:httpService, public app: AppComponent, public toastr: ToastsManager, vcr: ViewContainerRef) {

          this.toastr.setRootViewContainerRef(app.vcr);

          if (this.http.articuloGrabar.Id == 0)  this.tituloArticulo = "Nuevo Articulo";
          this.http.sw.mostrarArticulos = false;

       }

      tipomaquina = '';
      muestraAsignar: boolean = false;
      muestraSiNo: boolean = false;

      @Input() clientes:any;

      tituloArticulo:string = 'Editando Artículo número: ' + this.http.articuloGrabar.Id;

      articuloactual:any;

      loaded:boolean = false;
      cloaded:number = 0;

      maquinas: any;
      tipomaquinas: any;

      asignar() {
        this.tipomaquinas = [];
        this.muestraAsignar = true;
      }

      asignarTipo() {
        this.http.descargarMaquinas(0).subscribe( maquinas => {
            this.maquinas = maquinas;
            this.tipomaquinas = this.maquinas.filter( m=> m.descripcion === this.tipomaquina);
            console.log(this.articuloactual, this.tipomaquinas)
            this.muestraSiNo = true
        })
      }

      asignarSI() {
        this.muestraSiNo = false;
        this.muestraAsignar = false;
        let sql = ''; 
        this.tipomaquinas.forEach(maq => {
          if (sql !== '') sql = sql + ','
          sql = sql + '(' + maq.Id + ',' + this.http.articuloGrabar.Id + ',0)'
        });
        sql = 'Insert into tarifas ( Maquina, Articulo, Precio) values ' + sql
        console.log(sql)
        this.http.doSql(sql).subscribe(respuesta => {
          this.http.uploaded = respuesta;
      }, err => {
      }, () => {
          if (this.http.uploaded.Status == 1) {
              this.toastr.success('Actualizadas Tarifas','Tarifas');
          }else{
              this.toastr.error('Error actualizar Tarifas','Tarifas');
          }
    });
      }

      cancelarAsignar() {
        this.muestraAsignar = false;
        this.muestraSiNo = false;
      }

      volver() {
        this.http.sw.mostrarDatosarticulos = false;
        this.http.sw.mostrarMenu = true;
        this.http.sw.mostrarArticulos = true;
      }

      borrar(){
        this.http.loading = true;
          this.http.datosPost.action = 2; // borrar articulo
          this.http.datosPost.datos = this.http.articuloGrabar;
          this.http.articulo(this.http.datosPost).subscribe(respuesta => {
                this.http.uploaded = respuesta;

            }, err => {
              this.http.loading = false;
            }, () => {
                if (this.http.uploaded.Status == 1) {
                      this.toastr.success(this.http.uploaded.Text,'Articulos');
                      this.http.descargarArticulos().subscribe(respuesta => {
                        this.http.loading = false;
                        this.http.sw.mostrarDatosarticulos = false;
                      this.http.sw.mostrarMenu = true;
                      this.http.sw.mostrarArticulos = true;
                    });
                }else{
                  this.http.loading = false;
                    this.app.showtoast();
                    this.toastr.error(this.http.uploaded.Text,'Articulos');
                }
          });
      }

      grabar() {
        this.http.loading = false;
        this.http.datosPost.action = 1; // por defecto Update
        if (this.http.articuloGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
          this.http.datosPost.datos = this.http.articuloGrabar;
          this.http.articulo(this.http.datosPost).subscribe(respuesta => {
              this.http.uploaded = respuesta;

            }, err => {
              
            }, () => {
              if (this.http.uploaded.Status == 1) {
                  this.toastr.success(this.http.uploaded.Text,'Articulos');
                  this.http.descargarArticulos().subscribe(respuesta => {

                    this.http.sw.mostrarDatosarticulos = false;
                    this.http.sw.mostrarMenu = true;
                    this.http.sw.mostrarArticulos = true;
                    this.http.loading = false;

                  });
              }else{
                this.http.loading = false;
                  this.toastr.error(this.http.uploaded.Text,'Articulos');
              }
        });

      }




  }



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/datosarticulos/datosarticulos.component.ts